<div id="app" class="app">
    <div [ngClass]="{'mobile':Constant.checkMobile() && !Constant.checkTablet(),'tablet' : Constant.checkTablet()}">
      <router-outlet></router-outlet>
      <!-- chat box -->
    </div>
</div>

<div id="overlay" style="display: none;"></div>
<loading-modal [style.min-height]="minHeight" *ngIf="isShowLoading"></loading-modal>
<!-- <p *ngIf="(online$ | async) == false" >
  <span [ngClass]="noticeOffline()"></span>
</p> -->
<img [src]="Constant.logo_no_connect_internet" width="20" height="20" style="display: none;">

<img id="fileUpload" src="./assets/images/background/front-card.png" width="20" height="20" style="display: none;">

<progress-loading-api></progress-loading-api>